import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// Initialization for ES Users
import { Modal, Ripple, initTE } from "tw-elements";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";

export default function ForgetPassword() {
  useEffect(() => {
    initTE({ Modal, Ripple });
  }, []);
  function handleForgotPassword(e) {
    let em = document.getElementById("em").value;
    const id = toast.loading("Checking Email...", {
      position: toast.POSITION.TOP_RIGHT,
    });
    axios
      .get(`${base_url}/get/user/${em}`)
      .then((response) => {
        if (response.data.count == 1) {
          toast.update(id, {
            render: "Mail send successfully",
            type: "success",
            isLoading: false,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          document.getElementById("forgetform").reset();
        } else {
          toast.update(id, {
            render: "User Doesn't Exists With Given Details",
            type: "error",
            isLoading: false,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      })
      .catch((error) => {
        toast.update(id, {
          render: "Some issue occurred",
          type: "error",
          isLoading: false,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      });
  }
  
  return (
    <>
      {/* Button trigger modal */}
      <button
        type="button"
        className="text-indigo-700"
        data-te-toggle="modal"
        data-te-target="#exampleModalScrollable"
        data-te-ripple-init=""
        data-te-ripple-color="light"
      >
        Forgot Password ?
      </button>
      {/* Modal */}
      <div
        data-te-modal-init=""
        className="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div
          data-te-modal-dialog-ref=""
          className="pointer-events-none relative h-[calc(100%-1rem)] w-auto translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]"
        >
          <div className="pointer-events-auto relative flex max-h-[100%] w-full flex-col overflow-hidden rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
            <div className="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              {/*Modal title*/}
              <h5
                className="text-xl font-medium leading-normal text-neutral-800 dark:text-neutral-200"
                id="exampleModalScrollableLabel"
              >
                Send Password Reset E-mail
              </h5>
              {/*Close button*/}
              <button
                type="button"
                className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                data-te-modal-dismiss=""
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            {/*Modal body*/}
            <div className="relative overflow-y-auto p-4">
              <form
                id="forgetform"
                onSubmit={(e) => e.preventDefault()}
                className="space-y-5 m-8"
              >
                <div>
                  <label className="font-medium">Email</label>
                  <input
                    type="email"
                    required
                    id="em"
                    name="email"
                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                  />
                </div>
                <button></button>
              </form>
            </div>
            {/*Modal footer*/}
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              <button
                type="button"
                className="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200"
                data-te-modal-dismiss=""
                data-te-ripple-init=""
                data-te-ripple-color="light"
              >
                Close
              </button>
              <button
                onClick={(e) => {
                  handleForgotPassword(e);
                }}
                type="button"
                className="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                data-te-ripple-init=""
                data-te-ripple-color="light"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
